import { render, staticRenderFns } from "./DeleteFormDialog.vue?vue&type=template&id=07b48b32&scoped=true"
import script from "./DeleteFormDialog.vue?vue&type=script&lang=js"
export * from "./DeleteFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b48b32",
  null
  
)

export default component.exports